import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

class KPIDashboardWelcome extends Component {
    //
    //  constructor(props){
    //    super(props)
    //  }
    //
    render() {
        return (
            <div data-test='kpiDashboardWelcomeComponent' id="background-img">
                <Navbar />
                <Breadcrumb>
                    <Breadcrumb.Item href="">
                        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                    <Link to='/welcome'>Welcome</Link>
                        
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=""> <Link to='/open_loop'>Openloop</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href='/welcome_kpi_dashboard' active>KpiDashboard</Breadcrumb.Item>
                </Breadcrumb>

                <div className="container">
                    <div className="row" style={{ paddingTop: "4%" }}>
                        <div className="col-md-12 text-center">
                            <h1>Welcome to KPI Dashboard</h1>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="row" style={{ paddingTop: "6%" }}>
                            <div className="col-md-6 text-center" style={{ marginTop: "15px", marginBottom: "5%" }}>
                                <Link to="/camera_dashboard_level3" style={{ textDecoration: "none" }}>
                                    <div className="card" id="info-box">
                                        <div className="card-body align-items-center d-flex justify-content-center">
                                            <h4 style={{ color: "#622AD8" }}><b>Component - Camera</b></h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 1
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level2" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 2
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 3
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-6 text-center" style={{ marginTop: "15px", marginBottom: "5%" }}>
                                <Link to="/camera_dashboard_level3" style={{ textDecoration: "none" }}>
                                    <div className="card" id="info-box">
                                        <div className="card-body align-items-center d-flex justify-content-center">
                                            <h4 style={{ color: "#622AD8" }}><b>Component - Radar</b></h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 1
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 2
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 3
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-6 text-center" style={{ marginTop: "15px", marginBottom: "5%" }}>
                                <Link to="/camera_dashboard_level3" style={{ textDecoration: "none" }}>
                                    <div className="card" id="info-box">
                                        <div className="card-body align-items-center d-flex justify-content-center">
                                            <h4 style={{ color: "#622AD8" }}><b>Component - Lidar</b></h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 1
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 2
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/camera_dashboard_level3" className="nav-link" style={{ color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 3
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-6 text-center" style={{ marginTop: "15px", marginBottom: "5%" }}>
                                <Link to="/AutomateKPI" style={{ textDecoration: "none" }}>
                                    <div className="card" id="info-box">
                                        <div className="card-body align-items-center d-flex justify-content-center">
                                            <h4 style={{ color: "#622AD8" }}><b>Feature: AD v2.0</b></h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <Link to="/AutomateKPI/1" className="nav-link" style={{ textDecoration: "none", color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 1
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/AutomateKPI/4" className="nav-link" style={{ textDecoration: "none", color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 2
                                                </Link>
                                            </div>
                                            <div className="col-md-4">
                                                <Link to="/AutomateKPI/5" className="nav-link" style={{ textDecoration: "none", color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 3
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-md-6 text-center" style={{ marginTop: "15px", marginBottom: "5%" }}>
                                <Link to="/close_loop/individual/kpi/dashboard" style={{ textDecoration: "none" }}>
                                    <div className="card" id="info-box">
                                        <div className="card-body align-items-center d-flex justify-content-center">
                                            <h4 style={{ color: "#622AD8" }}><b>Feature: AD v3.0</b></h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <Link to="/close_loop/individual/kpi/dashboard" className="nav-link" style={{ textDecoration: "none", color: "#753DFF", fontWeight: "bold" }}>
                                                    Level 3
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        )
    }

}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };


export default KPIDashboardWelcome
